import useDynamicFacets from '../../hooks/useDynamicFacets';
import { FacetConfiguration } from '../../types';

interface Props {
  facetsConfiguration: Record<string, FacetConfiguration>;
}

/**
 * The collection listing's facet chrome: a centred row of pills under the heading, instead of the
 * category listing's sidebar. Every configured facet renders as the same pill group — see
 * `collectionMode` in useDynamicFacets.
 */
const CollectionFacets: React.FC<Props> = ({ facetsConfiguration }) => {
  const facets = useDynamicFacets({
    configuration: facetsConfiguration,
    collectionMode: true,
    render: ({ Component }) => <span>{Component}</span>,
  });

  return (
    <div className="2xl:pb-10 flex flex-col items-start justify-center gap-12 md:items-center lg:gap-24">{facets}</div>
  );
};

export default CollectionFacets;
